
import { Options, mixins } from "vue-class-component";
import { RoutingUtilityMixin } from "@/mixins";
import { hasAccessToAsset } from "@/utils/assetAccessChecker";
import ImageWithLoader from "@/components/ui/BaseImage/ImageWithLoader.vue";
import { AssetsInterface, AssetsTypesInterface, AssetType, ThumbSize } from "@/types";
import { useMq } from "vue3-mq";
import { PropType } from "vue";
import { settingsModule, usersModule } from "@/store";

@Options({
  name: "TreeNode",
  props: {
    asset: {
      type: Object as PropType<AssetsInterface>,
    },
    thumbSize: {
      type: String as PropType<ThumbSize>,
      default: "140x140",
    },
  },
  components: {
    ImageWithLoader,
  },
})
export default class TreeNode extends mixins(
  RoutingUtilityMixin
) {
  protected hasAccessToAsset = hasAccessToAsset;
  private mq = useMq();
  protected asset!: AssetsInterface;
  protected thumbSize!: ThumbSize;

  protected get isModels(): AssetType {
    return AssetType.Models;
  }

  protected get isVideo(): AssetType {
    return AssetType.Video;
  }

  protected get isLoadingUserAccess(): boolean {
    return usersModule.isLoading;
  }

  protected get assetMediaUrl(): string {
    if (this.asset?.assetType == 1) {
      return this.asset?.thumbs?.[this.thumbSize]?.url || "";
    }

    return this.asset?.src;
  }

  protected isActive(asset: AssetsInterface): boolean {
    const { assetSlug } = this.$route.params;
    if (!assetSlug) return false;

    return asset.slug === assetSlug;
  }

  protected getAssetsTypesAsString(types: Array<number>): string {
    return settingsModule.getSettings
      .map((s: AssetsTypesInterface) => types.includes(s.id) && this.$t(s.translationKey))
      .filter(Boolean)
      .join(" / ");
  }

  protected onSelect(): void {
    if (["xs", "sm", "md"].includes(this.mq.current))
      this.emitter.emit("asset-item-is-selected");
  }
}
